<script>
import Velocity from 'velocity-animate';

export default {
    name: 'BackToTop',
    render(h) {
        return this.$scopedSlots.default({
            linkEvents: {
                click(e) {
                    e.preventDefault();
                    Velocity(document.body, "scroll", { offset: "0", duration: "slow", mobileHA: false });
                }
            }
        })
    }
}
</script>


// WEBPACK FOOTER //
// src/js/components/BackToTop.vue